import { render, staticRenderFns } from "./Service2.vue?vue&type=template&id=20694cb5&scoped=true&"
import script from "./Service2.vue?vue&type=script&lang=js&"
export * from "./Service2.vue?vue&type=script&lang=js&"
import style0 from "./Service2.vue?vue&type=style&index=0&id=20694cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20694cb5",
  null
  
)

export default component.exports